import { render, staticRenderFns } from "./FormerEmployerTableComponent.vue?vue&type=template&id=70dc0c3c&scoped=true"
import script from "./FormerEmployerTableComponent.vue?vue&type=script&lang=ts"
export * from "./FormerEmployerTableComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc0c3c",
  null
  
)

export default component.exports